<template>
    <div>
        <vue-multiselect
            v-model="selectedOption"
            :options="options"
            :placeholder="placeholder"
            :taggable="false"
            :show-labels="false"
            track-by="name"
            label="name"
            :multiple="true"
            @select="selectHandyman($event)"
            @remove="selectHandyman($event)"
        ></vue-multiselect>
    </div>
</template>
<script>

export default {
    props: {
        modelValue: {
            type: [String, Object, Array, null, Number],
            default: null
        },
        placeholder: {
            type: String,
            default: 'Select Handyman'
        },
        orderDate: {
            type: String,
            default: null
        },
        orderTime: {
            type: String,
            default: null
        },
        handymanIds: {
            type: Array,
            default: () => [] // IDs of pre-selected handymen
        }
    },
    data() {
        return {
            options: [],
            selectedOption: null,
            schedules: []
        }
    },
    mounted() {
        this.getHandymanSchedules();
        this.$emitter.on('service_date_changed', (data) => {
            this.getHandymanSchedules();
        });
        this.$emitter.on('service_time_changed', (data) => {
            this.getHandymanSchedules();
        });
    },
    computed: {
        dateToFind() {
            return this.orderDate
        },
        timeToFind() {
            return this.orderTime
        }
    },
    watch: {
        modelValue(newVal) {
            //this.selectedOption = newVal;
        }
    },
    methods: {
        getHandymanSchedules() {
            let self = this;
            axios.post("/admin/handymans/get-hm-schedules")
                .then((response) => {
                    self.schedules = response.data.schedules;
                    self.prepareOptions();
                });
        },
        prepareOptions() {
            this.options = [];
            // Iterate through the handyman data
            // Convert timeToFind to HH:mm:ss format
            const timeToFind = this.$moment(this.timeToFind, "HH:mm:ss");
            Object.values(this.schedules).forEach(handymen => {
                handymen.forEach(handyman => {
                    let startTime = this.$moment(`${handyman.start_time}`, "HH:mm:ss");
                    let endTime = this.$moment(`${handyman.end_time}`, "HH:mm:ss");
                    if (handyman.schedule_date === this.dateToFind && handyman.status === 'available' && timeToFind.isBetween(startTime, endTime,undefined, '[]')) {
                        // Format the start and end times using Moment.js
                        const formattedStartTime = this.$moment(handyman.start_time, "HH:mm:ss").format("hh:mm A");
                        const formattedEndTime = this.$moment(handyman.end_time, "HH:mm:ss").format("hh:mm A");

                        // Push the formatted handyman data to the result array
                        this.options.push({
                            id: handyman.handyman_id,
                            name: `${handyman.full_name} (${formattedStartTime} - ${formattedEndTime})`
                        });
                    }
                });
            });

            // Filter options to get selected handymen
            this.selectedOption = this.options.filter(option =>
                this.handymanIds.includes(option.id)
            );
        },
        selectHandyman(event) {
            // Get the all ids from the selected option
            const ids = this.selectedOption.map(option => option.id);
            this.$emit('update:modelValue', ids);
        }
    }
}
</script>
